// Libs
import React from 'react'
import PropTypes from 'prop-types'

// Styles
import {
  // cellStyle,
} from './styles'

import { lightGrey, primary } from 'fc-styles/src/colors'

import filterIcon from 'fc-icons/svg/filter.svg'

// Images
const filterIconInactive = filterIcon.replace('<svg', `<svg fill="${lightGrey(0.5)}"`)
const filterIconActive = filterIcon.replace('<svg', `<svg fill="${primary()}"`)

// Local Styles
const inputStyle = ({value}) => ({
  border: 0,
  width: '100%',
  outline: 'none',
  backgroundColor: 'transparent',
  backgroundImage: `url('data:image/svg+xml;utf-8,${value ? filterIconActive : filterIconInactive}')`,
  backgroundPosition: 'left 5px center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 10,
  paddingLeft: 20,
})

// Exports
export const FilterInput = ({value, attr, type, width, placeholder, onFilter}) => (
  <div style={{
    display: 'flex',
    flex: `0 0 ${width}%`,
  }}>
    <input
      style={inputStyle({value})}
      type='text'
      onChange={onFilter}
      value={value}
      placeholder={placeholder || attr}
    />
  </div>
)

FilterInput.propTypes = {
  value: PropTypes.any,
  attr: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  onFilter: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['number', 'string', 'boolean', 'date']),
  placeholder: PropTypes.string,
}

export default FilterInput
